<template>
    <div class="x-selection-dialog">
        <el-container>
            <el-aside v-if="showTree && queryConfig?.tree" style="height:600px;">
                <el-scrollbar class="scroll" height="100%">
                    <x-filter-view
                        :config="getTreeConfig(queryConfig)"
                        :query-params="queryParams"
                        :filter-data="filterData"
                    ></x-filter-view>
                </el-scrollbar>
            </el-aside>
            <el-container>
                <div style="width:100%;">
                    <x-query-view
                        v-if="queryConfig?.query"
                        :config="queryConfig?.query"
                        :query-params="queryParams"
                        :showExtQuery="false"
                    ></x-query-view>
                    <div v-if="selectType != SelectType.SINGLE_SELECT" class="x-tags">
                        <x-tag :config="getTagConfig(config, dataOptions)" v-model:model-value="selectedValue" @close="closeHandler"></x-tag>
                    </div>
                    <x-table-view
                        :config="getSearchTableConfig(queryConfig?.body)"
                        :query-params="queryParams"
                        :filter-data="filterData"
                        v-model:selected="selectedDatas"
                        @update:selected="selectedChangeHandler"
                    ></x-table-view>
                </div>
            </el-container>
        </el-container>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import XQueryView from './XQueryView.vue';
import XTag from '../components/base/XTag.vue';
import XTableView from './XTableView.vue';
import XFilterView from './XFilterView.vue';
import SelectType from '../components/data/SelectType';
// import ModuleCenter from '../datamodule/ModuleCenter';
import ViewType from '../dataview/ViewType';
import PageFlowEngine from '../pageflow/PageFlowEngine';
import { useTokenStore } from '../store/TokenStore';
import { dayjs } from 'element-plus';
import TimeService from '../remoteservice/TimeService';

const inst = getCurrentInstance();
const token = useTokenStore();

const filterData = ref({_r:null, data:null, module:null});

const props = defineProps({
    config: { default: null },
    selectType: { default: SelectType.MULTIPLE_SELECT },
    selected: { default: null },
    showTree: { default: true },
    data: { default: null },
})

defineEmits({
    'update:selected': null,
})

const dataOptions = ref(null);
const selectedValue = ref(null);
const updateOptions = (selected)=> {
    const keyField = props.config?.keyField || 'id';
    const nameField = props.config?.nameField || 'name';
    const options = [];
    let value = [];

    if (selected) {
        if (selected instanceof Array) {
            value = [];
            for (const data of selected) {
                const v = data[keyField];
                const n = data[nameField];
                value.push(v);
                options.push({value:v, label:n});
            }
        } else {
            const v = selected[keyField];
            const n = selected[nameField];
            value = v;
            options.push({value:v, label:n})
        }
    }
    dataOptions.value = options;
    selectedValue.value = value;
}

const selectedDatas = ref(null);
watch(()=> props.selected, (value)=> {
    updateOptions(value);
    selectedDatas.value = value;
}, {immediate:true})

const getTreeConfig = (config)=> {
    if (!config) return null;
    if (!config.tree.targetModule) config.tree.targetModule = config.query.view.getModuleCode();
    return config.tree;
}
const getTagConfig = (config, dataOptions)=> {
    return Object.assign({}, config, {dataOptions:dataOptions || [], closable:true});
}

const buildConfig = (config)=> {
    return {type:ViewType.PAGE, tree:config.tree, query:{
        type:ViewType.QUERY, withDefaultButtons:true, view:{
            module:config.module, fields:config.queryFields
        }
    }, title:{name:config.title}, body:{
        type:ViewType.TABLE, withDefaultButtons:false, defaultFields:['selection', 'index'], view:{
            module:config.module, fields:config.listFields
        }
    }}
}
const getFilter = (filter)=> {
    if (!filter) return {query:{}, options:null};
    const query = {};
    const options = {};
    for (const [key, value] of Object.entries(filter)) {
        if (value instanceof Object && !(value instanceof Array)) {
            if (value.in) {
                query[key] = value.in.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-in';
            } else if (value.not) {
                query[key] = value.not.split(/\s*\,\s*/).reverse();
                options[key] = 'notin';
            } else if (value.notin) {
                query[key] = value.notin.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-notin';
            } else if (value.relate) {
                query[key] = value.relate;
                options[key] = 'multi-relate';
            }
        } else {
            query[key] = value;
        }
    }
    return {query:query, options:options};
}
const getQuery = (queryConfig, data)=> {
    if (!queryConfig) return {};
    const query = {};
    const options = {};
    queryConfig = queryConfig.replace(/([\w\,\.\:]+?)\?(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $2, $3)=> {
        let keys = $1;
        let o = $2 || null;
        let ov = null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (v == null) v = '';
        keys = keys.split(/[\,\.\:]/);
        let key = keys.shift();
        while(query[key]) key += '+';
        const value = [keys, ['' + v]];
        query[key] = value;
        options[key] = 'multi-relate';
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)(\=|\>|\<)(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $c, $2, $3)=> {
        const c = $c;
        let key = $1;
        while(query[key]) key += '+';
        let o = $2 || null;
        let ov =  null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (c == '=') {
            if (v != null) query[key] = v;
        } else if (c == '>') {
            if (v != null) {
                if (!query[key]) query[key] = [v, null];
                else query[key][0] = v;
            }
            options[key] = 'range';
        } else if (c == '<') {
            if (v != null) {
                if (!query[key]) query[key] = [null, v];
                else query[key][1] = v;
            }
            options[key] = 'range';
        }
        
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)\=([^\s\&]+)/g, ($0, $1, $2)=> {
        const key = $1
        let value = $2.split(/\s*\,\s*/);
        value = value.map((v)=>JSON.parse(v));
        if (value.length == 1) value = value[0];
        query[key] = value;
        return '';
    })
    return {query:query, options:options};
}
const queryParams = ref(null);

const queryConfig = ref(PageFlowEngine.transformSearchConfig(buildConfig(props.config)));
watch(()=> props.config, (value)=> {
    const f = getFilter(props.config?.filter);
    const def = getQuery(props.config?.condition, props.data);
    queryParams.value = {query:Object.assign({}, f?.query, def?.query), options:Object.assign({}, f?.options, def?.options)};
    const conf = PageFlowEngine.transformSearchConfig(buildConfig(value));
    if (conf.query) conf.query.default = def;
    queryConfig.value = conf;
}, {immediate:true})

const getSearchTableConfig = (config)=> {
    if (!config) return null;
    config.withDefaultButtons = false;
    config.defaultFields = ['selection', 'index'];
    config.selectType = props.selectType;
    return config;
}

const closeHandler = (key)=> {
    // console.log(data);
    const keyField = props.config?.keyField || 'id';
    const selected = [];
    for (const data of props.selected) {
        if (data[keyField] == key) continue;
        selected.push(data);
    }
    inst.emit('update:selected', selected);
}
const selectedChangeHandler = (selected)=> {
    updateOptions(selected);
    inst.emit('update:selected', selected);
    // defaultOptions.value = mergeOpions(selected);
    // inst.emit('update:dataOptions', defaultOptions.value);
    // const keyField = props.config?.keyField || 'id';
    // if (props.selectType != SelectType.SINGLE_SELECT) {
    //     let values = [];
    //     for (const data of selected) {
    //         values.push(data[keyField]);
    //     }
    //     const value = values;
    //     modelValue.value = value;
    //     inst.emit('update:modelValue', value);
    // } else {
    //     const value = selected ? selected[keyField] : null;
    //     modelValue.value = value;
    //     inst.emit('update:modelValue', value);
    // }
}

</script>